import { useMutation, useQueryClient } from "@tanstack/react-query";
import { adminRaffleKeys } from "Api/Queries/Raffle/useAdminRaffleRoundsQuery";
import {
  type CreateRaffleRoundRequest,
  postAdminRaffleRounds,
  type RaffleRoundDto,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: (result: RaffleRoundDto) => void;
  onError?: () => void;
};

export const useCreateRaffleRoundMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (data: CreateRaffleRoundRequest) => postAdminRaffleRounds(data),
    ),
    onSuccess: (data: RaffleRoundDto) => {
      queryClient.invalidateQueries({ queryKey: adminRaffleKeys.all });
      onSuccess?.(data);
    },
    onError,
  });
};
